import { DcBaseComponent } from '@deleteagency/dc';

export default class SearchFiltersPriceComponent extends DcBaseComponent {
    static getNamespace() {
        return 'filter-price';
    } 

    onInit() {
        
        this.wrapper = document.querySelector('.js-price-wrapper');

        this.priceMin = document.querySelector('.js-price-min');
        this.priceMax = document.querySelector('.js-price-max');
        this.priceModalMin = document.querySelector('.js-price-modal-min');
        this.priceModalMax = document.querySelector('.js-price-modal-max');

        const optionsMax = this.priceMax.querySelectorAll('option');
        const optionsMin = this.priceMin.querySelectorAll('option');

        const optionsModalMin = this.priceModalMin.querySelectorAll('option');
        const optionsModalMax = this.priceModalMax.querySelectorAll('option');

        // If a  user changes the minimum price on the main search filters        
        this.priceMin.addEventListener('change', () => {
            const setPrice = parseInt(this.priceMin.value);

            optionsMax.forEach(option => {   
                this._setMinFilters(setPrice, option);
            });
            
            optionsModalMin.forEach(option => {
                this._matchPrice(setPrice, option);
            });

            optionsModalMax.forEach(option => {
                this._setMinFilters(setPrice, option);
            });

        });
        
        // If a  user changes the maximum price on the main search filters
        this.priceMax.addEventListener('change', () => {
            const setPrice = parseInt(this.priceMax.value);

            optionsMin.forEach(option => {            
                this._setMaxFilters(setPrice, option);                    
            });
            
            optionsModalMax.forEach(option => {
                this._matchPrice(setPrice, option);                
            });

            optionsModalMin.forEach(option => {
                this._setMaxFilters(setPrice, option);
            });

        });        

        // If a  user changes the minimum price on the modal search filters
        this.priceModalMin.addEventListener('change', () => {
            const setPrice = parseInt(this.priceModalMin.value);

            optionsModalMax.forEach(option => {                
                this._setMinFilters(setPrice, option);
            });

            optionsMin.forEach(option => {
                this._matchPrice(setPrice, option);
            });

            optionsMax.forEach(option => {
                this._setMinFilters(setPrice, option);
            });

        });

        // If a  user changes the maximum price on the modal search filters
        this.priceModalMax.addEventListener('change', () => {
            const setPrice = parseInt(this.priceModalMax.value);

            optionsModalMin.forEach(option => {                
                this._setMaxFilters(setPrice, option);
            });
            
            optionsMax.forEach(option => {
                this._matchPrice(setPrice, option);
            });

            optionsMin.forEach(option => {
                this._setMaxFilters(setPrice, option);
            });

        });
        
    }


    _setMinFilters(setPrice, option){
        const optionValue = parseInt(option.value);
        if (optionValue <= setPrice) {
            if (option.value !== '') {
                option.setAttribute('disabled', true);
                option.removeAttribute('selected');
                option.style.display = 'none';
            }
        } else {
            option.removeAttribute('disabled');
            option.style.display = 'block';
        }
    }

    _setMaxFilters(setPrice, option){
        const optionValue = parseInt(option.value);
        if (optionValue >= setPrice) {
            if (option.value !== '') {
                option.setAttribute('disabled', true);
                option.removeAttribute('selected');
                option.style.display = 'none';
            }
        } else {
            option.removeAttribute('disabled');
            option.style.display = 'block';
        }
    }

    _matchPrice(setPrice, option){
        const optionValue = parseInt(option.value);
        if (optionValue === setPrice) {
            option.setAttribute('selected', true);
        } else {
            option.removeAttribute('selected');
        }
    }

}
